import type { DefaultOptionType } from 'antd/es/select';
export namespace NAntdLocalTypes {
  export type CheckboxOptionType = {
    label: React.ReactNode;
    value: string;
    disabled?: boolean;
  };
}

export type Options = DefaultOptionType[];
